import { InputNumber } from 'antd'

import { numberFormatting } from '../../utils/customFunctions'

const ALLOWED_CONTROL_KEYS = [
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
]

const NUMERIC_PARSER = (value, precision) => {
  if (value == null || value === '') return value
  const str =
    precision === 0
      ? parseInt(Number(value))
      : String(value).replace(/[^\d.-]/g, '')
  const hasMinus = str.startsWith('-')
  const numPart = str.replace(/-/g, '')
  return hasMinus ? `-${numPart}` : numPart
}

function ANTDInputNumber({
  onKeyDown,
  onPaste,
  formatter,
  numberFormat = false,
  ...props
}) {
  const handleKeyDown = e => {
    const { key, ctrlKey, metaKey } = e
    if (ALLOWED_CONTROL_KEYS.includes(key)) return
    if (ctrlKey || metaKey) {
      if (['a', 'c', 'v', 'x'].includes(key.toLowerCase())) return
    }
    if (/^\d$/.test(key)) return
    if (key === '.' && props.precision !== 0) return
    if (key === '-' && (props.min == null || props.min < 0)) return
    e.preventDefault()
  }

  const handlePaste = e => {
    e.preventDefault()
    const raw = e.clipboardData?.getData('text') || ''
    const cleaned =
      props.precision === 0
        ? parseInt(Number(raw))
        : raw.replace(/[^\d.-]/g, '')
    if (cleaned === '' || cleaned === '-') return
    const num = parseFloat(cleaned)
    if (!Number.isNaN(num)) props.onChange?.(num)
  }

  return (
    <InputNumber
      {...props}
      onKeyDown={e => {
        handleKeyDown(e)
        onKeyDown?.(e)
      }}
      onPaste={e => {
        handlePaste(e)
        onPaste?.(e)
      }}
      formatter={value => {
        if (value == null || value === '') return value
        let formattedValue = value
        const precision = props.precision ?? 3
        if (props.precision) {
          const [int, dec = ''] = String(value).split('.')
          formattedValue =
            dec.length <= precision
              ? Number(value)
              : `${int}.${dec.slice(0, precision)}`
        }
        if (formatter) {
          formattedValue = formatter(formattedValue)
        }
        return numberFormat ? numberFormatting(formattedValue) : formattedValue
      }}
      parser={value => NUMERIC_PARSER(value, props.decision)}
    />
  )
}
export default ANTDInputNumber

// format precision on blur
// function ANTDInputNumber({ onBlur, ...props }) {
//   const formatValue = value => {
//     if (!props.precision) return value
//     if (value == null || value === '') return value
//     const precision = props.precision || 3
//     const [int, dec = ''] = String(value).split('.')
//     if (dec.length <= precision) return value
//     const newVal = `${int}.${dec.slice(0, precision)}`
//     return newVal ? Number(newVal) : null
//   }

//   const handleBlur = e => {
//     // Apply formatter on blur if precision is set
//     if (props.precision) {
//       const currentValue = props.value
//       if (currentValue != null && currentValue !== '') {
//         const formattedValue = formatValue(currentValue)
//         // Update the value through onChange to sync with form state
//         // Only update if the formatted value is different
//         if (formattedValue !== currentValue && props.onChange) {
//           props.onChange(formattedValue)
//         }
//       }
//     }
//     // Call the original onBlur if provided
//     if (onBlur) {
//       onBlur(e)
//     }
//   }

//   return (
//     <InputNumber
//       {...props}
//       onBlur={handleBlur}
//       parser={value => value?.replace(/[^\d.]/g, '')}
//     />
//   )
// }
